<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Discipline Categories</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
         <add-discipline-categories
            v-if="pagepermission.insertable"
            @created="handleCreated"
          />
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <discipline-categories-table
              :rolesetting="pagepermission"
              :categories="data"
              :loading="loading"
              @updateTable="handleUpdateTable"
            />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DisciplineCategoriesTable from '@/components/disciplineManagement/disciplineCategories/Table/index'
import AddDisciplineCategories from '@/components/disciplineManagement/disciplineCategories/Form/Add'

export default {
  components: {
    DisciplineCategoriesTable,
    AddDisciplineCategories,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('class', 22)
    rc.then((data) => {
      console.log(data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function () {
    this.getDisciplineCategories()
  },
  data: function () {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 20,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    getDisciplineCategories: function () {
      //   this.loading = true
      this.$http
        .get('/api/student-discipline-category', {
          params: {
            limit: this.pageSize,
            page: this.current,
          },
        })
        .then(({ data }) => {
          console.log(data)
          this.loading = false
          this.data = data.data
          console.log(this.data)
          this.meta = data.meta
        })
    },
    handleCreated: function () {
      this.getDisciplineCategories()
    },
    handleUpdateTable: function () {
      this.getDisciplineCategories()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getDisciplineCategories()
    },
    onChange(current) {
      this.current = current
      this.getDisciplineCategories()
    },
  },
}
</script>
<style>
.error {
  padding: 25px 5px;
}
</style>
